(function () {
    'use strict';

    angular
        .module('showcaseApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {

        var resolve = {
            translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                $translatePartialLoader.addPart('seller-activities');
                $translatePartialLoader.addPart('seller-campaigns');
                $translatePartialLoader.addPart('campaign');
                $translatePartialLoader.addPart('customers');
                $translatePartialLoader.addPart('global');
                $translatePartialLoader.addPart('communication');
                $translatePartialLoader.addPart('reports');
                $translatePartialLoader.addPart('flyers');
                return $translate.refresh();
            }]
        };

        $stateProvider
            .state('seller-campaigns', {
                parent: 'admin',
                url: '/seller-campaigns',
                data: {
                    authorities: ['READ_SELLER_CAMPAIGNS', 'SELLER_CAMPAIGNS'],
                    pageTitle: 'seller-campaigns.list.title.plural'
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/admin/seller-campaigns/seller-campaigns.html',
                        controller: 'SellerCampaignsController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    type: null
                },
                resolve: resolve
            }).state('seller-campaigns.seller-activities', {
                url: '/{campaignId}/seller-activities',
                data: {
                    authorities: ['READ_SELLER_CAMPAIGNS'],
                    pageTitle: 'seller-activities.title.plural'
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/admin/seller-campaigns/seller-activities/seller-activities.html',
                        controller: 'SellerActivitiesController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                },
                resolve: resolve
            });
    }
})();
